var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
export function useNavHistoryContext() {
    var _a = useState([]), navHistory = _a[0], setNavHistory = _a[1];
    function addHistory(location) {
        setNavHistory(__spreadArray(__spreadArray([], navHistory, true), ["".concat(location.pathname).concat(location.search || '')], false));
    }
    function navigateAndAddHistory(path, navigate, location) {
        addHistory(location);
        navigate(path);
    }
    function removeLastPath() {
        var newNavHistory = __spreadArray([], navHistory, true);
        if (newNavHistory.length > 0) {
            newNavHistory.splice(newNavHistory.length - 1, 1);
        }
        setNavHistory(newNavHistory);
    }
    function navigateToPreviousPath(defaultPath, navigate) {
        var previousPath = navHistory.length > 0 ? navHistory[navHistory.length - 1] : defaultPath;
        removeLastPath();
        navigate(previousPath);
    }
    return {
        navHistory: navHistory,
        addHistory: addHistory,
        navigateAndAddHistory: navigateAndAddHistory,
        removeLastPath: removeLastPath,
        navigateToPreviousPath: navigateToPreviousPath,
    };
}
